import ProjectUser_checkDelete from "./check-project-user-delete"

export default class ModalProjectUserActions {

    public params           : any
    public updateCallback   : callback
    public reassignCallback : {(view: string, itemsToReassign?: any): void}
    public onReassignDone?   : callback

    constructor(params: any, updateCallback: callback, reassignCallback: {(view: any, itemsToReassign: any): void}) {
        this.params             = params

        this.updateCallback     = updateCallback
        this.reassignCallback   = reassignCallback
    }

    onAccessSelect = (value: any) => {
        const request = gd.api.ProjectUser.updateAccess(this.params.projectUser.projectId, this.params.projectUser.userId, value)
        request.done(result=>{
            if (!_.isNil(result.result)) { // no items to reassign
                this.params.projectUser.access = value

                this.updateCallback(()=>{
                    if (this.params.onChange) this.params.onChange(this.params.projectUser)
                })
            } else {
                this.onReassignDone = () => this.onAccessSelect(value).done(()=>this.reassignCallback('default'))
                this.reassignCallback('reassign-access', result)
            }
        })

        return request
    }

    onWatchAllSelect = (value: boolean) => {
        this.params.projectUser.watchAll = value

        // callback
        if (this.params.onChange) this.params.onChange(this.params.projectUser)

        const request = gd.api.ProjectUser.updateWatchAll(this.params.projectUser.projectId, this.params.projectUser.userId, value)
        request.done(()=>{
            this.updateCallback()
        })
    }

    checkDelete = () => {
        return ProjectUser_checkDelete(this.params.projectUser, this.params.projectUsers)
    }

    onDeleteConfirmed = () => {
        const request = gd.api.Project.deleteUser(this.params.projectUser.projectId, this.params.projectUser.userId)

        request.done(result=>{
            if (!_.isNil(result.result)) { // no items to reassign
                gd.modal.hide();
            } else {
                this.onReassignDone = () => gd.api.Project.deleteUser(this.params.projectUser.projectId, this.params.projectUser.userId).done(()=>gd.modal.hide())
                this.reassignCallback('reassign-delete', result);
            }
        })
    }

    reassignUserItems = (tasksReassignTo: ID, eventsReassignTo: ID, projectsReassignTo: ID) => {
        const request = gd.api.Project.reassignItems(this.params.projectUser.projectId, this.params.projectUser.userId, tasksReassignTo, eventsReassignTo, projectsReassignTo);
        request.done(()=> {
            if (this.onReassignDone) this.onReassignDone()
            this.onReassignDone = undefined
        })

        return request
    }
}
